import { createApp } from 'vue'
import App from "./App.vue";
import router from './router'
import './assets/rem.ts'
import './assets/reset.css'
import { Lazyload } from 'vant';
const app = createApp(App)
app.use(router).use(Lazyload).mount("#app");
